

import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firebase-firestore';

 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const secondaryAppConfig = { 
  apiKey : "AIzaSyC31nWz7gJ5M5THyyevc1uX42hs4Avrp1w" , 
  authDomain : "hojouzate-main.firebaseapp.com" , 
  databaseURL : "https://hojouzate-main-default-rtdb.firebaseio.com" , 
  projectId : "hojouzate-main" , 
  storageBucket : "hojouzate-main.appspot.com" , 
  messagingSenderId : "161531194768" , 
  appId : "1:161531194768:web:c99fbc3ce69864c41dd715" , 
  measurementId : "G-XRCVCEJ4NS" 
};
 
  
  var clientFirebase = firebase.initializeApp(secondaryAppConfig, "clientFirebase");

  export default clientFirebase;
  
